import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { compose, createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { initAxiosClient } from "src/utils/axios";
import LiffProvider from "src/providers/Liff";
import AuthProvider from "src/providers/Auth";
import ToastProvider from "src/providers/Toast";
import { liffId, stage } from "src/config";
import reducers from "src/reducers";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { SnackbarProvider } from "notistack";

const reducer = combineReducers(reducers);
const store = createStore(
  reducer,
  compose(
    applyMiddleware(thunk)
    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )
);
initAxiosClient(store);
const theme = createTheme({
  palette: {
    primary: {
      main: "#7b7c7e",
      contrastText: "#7b7c7e",
    },
    secondary: {
      main: "#fff",
      contrastText: "#7b7c7e",
    },
  },
  typography: {
    fontFamily: "LaPrairie-Light, '微軟正黑體', Arial, sans-serif",
    fontSize: 12,
    subtitle1: {
      fontSize: 14,
    },
    subtitle2: {
      fontSize: 18,
    },
    string: {
      fontSize: 14,
    },
  },
});
render(
  <Provider store={store}>
    <LiffProvider
      liffId={liffId}
      mock={stage === "local" ? require("./mock").liff : undefined}
    >
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <SnackbarProvider maxSnack={3}>
            <ToastProvider>
              <App />
            </ToastProvider>
          </SnackbarProvider>
        </ThemeProvider>
      </AuthProvider>
    </LiffProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
